import { ModalForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import useEngineeringService from '../useEngineeringService';
import { EngineeringBugReport, SaveBugPayload } from '../types';
import { modalActionsSx } from '../shared/modalActionsSx';
import BugForm from './BugForm';
import { bugValidation } from './bugValidation';

interface UpdateBugModalProps {
  projectId: string;
  bug: EngineeringBugReport | null;
  isOpen: boolean;
  onClose: () => void;
  onSaved: (bug: EngineeringBugReport) => void;
}

const UpdateBugModal = ({ projectId, bug, isOpen, onClose, onSaved }: UpdateBugModalProps) => {
  const { updateBug } = useEngineeringService();

  if (!bug) return null;

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Update bug">
      <ModalForm
        modalOpen={isOpen}
        closeModal={onClose}
        submitButtonText="Update"
        actionsSx={modalActionsSx}
        getDataFunc={() => {
          const { shortDescription, isCritical, linkToDetails, notes } = bug;
          return Promise.resolve({
            shortDescription: shortDescription ?? '',
            isCritical: isCritical == null ? null : String(isCritical),
            linkToDetails: linkToDetails ?? '',
            notes: notes || '',
          });
        }}
        submitFormFunc={async values => {
          const { shortDescription, isCritical, linkToDetails, notes } = values;
          const payload: SaveBugPayload = {
            id: bug.id,
            shortDescription,
            isCritical: isCritical === 'true',
            linkToDetails: linkToDetails || null,
            notes: notes || '',
          };
          return { result: await updateBug(projectId, bug.id, payload) };
        }}
        afterSubmit={{
          message: 'You are awesome! Bug has been successfully updated.',
          execute: (response: { result: EngineeringBugReport }) => onSaved(response.result),
        }}
        getValidationSchemaFunc={() => Promise.resolve(bugValidation)}
      >
        <BugForm />
      </ModalForm>
    </Modal>
  );
};

export default UpdateBugModal;
